import ScrollReveal from '@/components/base/ScrollReveal';
import ArticleLink from '@/components/feature/ArticleLink';
import { riskMistakes } from '@/mocks/riskManagementPage';

export default function RiskMistakes() {
  return (
    <section
      id="mistakes"
      className="scroll-mt-[7.5rem] border-b border-background-200 bg-background-100/60 md:scroll-mt-[9rem]"
    >
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20 lg:px-10">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <span className="mb-3 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-primary-600">
              <span className="h-px w-6 bg-accent-500" />
              ข้อควรระวัง
            </span>
            <h2 className="text-balance font-heading text-2xl font-semibold leading-tight text-foreground-950 md:text-[34px]">
              ข้อผิดพลาดในการบริหารความเสี่ยงที่ควรหลีกเลี่ยง
            </h2>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              ความเสียหายส่วนใหญ่ไม่ได้มาจากการวิเคราะห์ผิด แต่มาจากการปล่อยให้ขนาดความเสี่ยงหลุดจากแผน
              ทั้งตอนที่มั่นใจเกินไปและตอนที่กำลังขาดทุน
            </p>
            <p className="mt-4 flex items-start gap-2 rounded-lg border border-accent-200 bg-accent-50/70 p-3.5 text-xs leading-relaxed text-foreground-700">
              <i className="ri-shield-check-line mt-0.5 shrink-0 text-base text-accent-800" aria-hidden="true" />
              การบริหารความเสี่ยงไม่ทำให้การขาดทุนหายไป แต่ทำให้ขาดทุนแต่ละครั้งอยู่ในระดับที่พอร์ตยังไปต่อได้
            </p>
          </div>

          <ol className="flex flex-col">
            {riskMistakes.map((mistake, index) => (
              <ScrollReveal as="li" key={mistake.title} delay={index * 50} className="border-t border-background-300/70 last:border-b">
                <ArticleLink
                  to={mistake.to}
                  className="group/link flex items-start gap-4 py-5 pr-1 transition-colors"
                  aria-label={`อ่านบทความเกี่ยวกับ ${mistake.title}`}
                >
                  <span className="mt-1 font-num text-xs font-semibold text-foreground-400">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover/link:text-primary-700 md:text-lg">
                      {mistake.title}
                    </span>
                    <span className="mt-1.5 block text-[13px] leading-relaxed text-foreground-600">{mistake.body}</span>
                  </span>
                  <i
                    className="ri-arrow-right-up-line mt-1 shrink-0 text-lg text-foreground-300 transition-colors group-hover/link:text-primary-600"
                    aria-hidden="true"
                  />
                </ArticleLink>
              </ScrollReveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}